<style lang="less" scoped>
@import "./style/1.less";
@import './style/2.less';
</style>

<template>
  <div class="dredge-contain">
    <img class="dredge-header" src="https://s6.bihukankan.com/img/0927banner.png" alt="banner"/>
    <div class="tabs between">
      <div class="tab" :class="activeTab=== 0?'tab-active':''" @click="changeTab(0)">商家运营</div>
      <div class="tab" :class="activeTab=== 1?'tab-active':''" @click="changeTab(1)">品牌机构</div>
      <div class="tab" :class="activeTab=== 2?'tab-active':''" @click="changeTab(2)">集团品牌主</div>
    </div>
    <!--   套餐列表   -->
    <div class="pack-list">
      <div class="pack-list__item" :class="{'pack-list__active' : activePack === index}"
           v-for="(ele,index) of showPackList" :key="index" @click="activePack = index">
        <img v-if="activePack === index" src="https://s6.bihukankan.com/img/1642563535icon-checked.png"
             class="pack-list__icon-checked">
        <img v-if="ele.id === 84" src="https://s6.bihukankan.com/img/1695796077144.png" alt="" class="pack-list__hot">
        <div class="pack-list__item__title">{{ ele.name }}</div>
        <div class="pack-list__item__sub-title">¥{{ (ele.price / 100) }}</div>
      </div>
    </div>

    <!-- 套餐图片 -->
    <div class="image-box" v-if="activeTab === 0">
      <img :src="infoImageList['advanced']" class="image-box__img" mode="widthFix"/>
    </div>

    <div class="image-box" v-if="activeTab === 1">
      <img :src="infoImageList['professional']" class="image-box__img" mode="widthFix"/>
    </div>

    <div class="image-box" v-if="activeTab === 2">
      <img :src="infoImageList['exclusive']" class="image-box__img" mode="widthFix"/>
    </div>
    <!--   Header   -->
    <img src="https://s6.bihukankan.com/img/1699326316vipHeader.png" class="normal-image-header" mode="widthFix"/>
    <!--   主图   -->
    <img :src="infoImageList['main']" class="normal-image" mode="widthFix"/>
    <div class="pay-box">
      <div class="pay-box__aside">
        <div class="pay-box__aside__title">{{ checkedPack.name }}</div>
        <div class="pay-box__aside__sub-title">¥{{ checkedPack.price / 100 }}</div>
      </div>
      <div class="pay-box__button" @click="createOrder">立即支付</div>
    </div>
  </div>
</template>

<script>
import pay from "@/helper/pay";
import isWxProgram from "@/helper/isWxProgram";
import {goMiniProgram} from "@/helper/wxprogramSDK";

export default {
  data() {
    return {
      packList: [], // 套餐包
      activeTab: 0, // 选中的版本
      activePack: 1, // 选中的套餐
      bannerImg: '', // 首页图片地址
      infoImageList: {}, // 权益图片
    };
  },
  computed: {
    /** 展示的套餐列表 **/
    showPackList() {
      return this.packList.length ? this.packList[this.activeTab] : []
    },
    checkedPack() {
      return this.showPackList.length ? this.showPackList[this.activePack] : {}
    }
  },
  mounted() {
    this.checkLogin() // 检查登录
    this.query() // 查询包
    this.getAdData() // 查询图
  },
  methods: {
    checkLogin() {
      const redirectUrl = 'https://login.bihukankan.com/mobile?wx_oa_appid=wxc3c24b5b6b23c158&bh_appid=10&redirect_uri=https://m.bihukankan.com/dredgeVip&redirect_uri_type=h5'
      if (!this.$store.state.userLevel) return window.location.replace(redirectUrl)
      isWxProgram().
      then( _ => { // 微信小程序环境
        this.$router.back()
        goMiniProgram('/pages/dredgeVip/main',{})
      }).
      catch(() => {})
    },
    /** 切换tab **/
    changeTab(tabIndex) {
      this.activeTab = tabIndex
      this.activePack = 1
    },
    /** 获取广告位数据 **/
    getAdData() {
      /** 获取banner **/
      this.$api.get('/adP/v3/module?spaceId=75&sort=priority&order=ASC').then(res => {
        if (res.data.data[0].config.src) {
          this.bannerImg = res.data.data[0].config.src
        }
      })
      /** 获取权益图片地址 **/
      this.$api.get('/adP/v3/module?spaceId=76&sort=priority&order=ASC').then(res => {
        if (res.data.data) {
          const list = res.data.data.reduce((total, ele) => Object.assign(total, {
            [ele.config.name]: ele.config.src
          }), {})
          this.infoImageList = list
        }
      })
    },
    /** 获取套餐包 **/
    query() {
      this.$get({
        road: 'businessPackageScene',
        params: {alias: 'VipV2Guide', client: 'miniProgram'},
        version: 'v2'
      }).then(res => {
        let scene = res.scene
        let pack = [...new Array(3)]
        let temp = []
        temp = scene.filter(ele => ele.name === '高级版')
        pack[0] = temp.map(ele => {
          return ele.businessPackage
        })
        temp = scene.filter(ele => ele.name === '专业版')
        pack[1] = temp.map(ele => {
          return ele.businessPackage
        })
        temp = scene.filter(ele => ele.name === '尊享版' || ele.name === '专享版')
        pack[2] = temp.map(ele => {
          return ele.businessPackage
        })
        this.packList = pack
        this.hideLoading();
      });
    },
    // 进行api支付
    createOrder() {
      this.$showLoading()
      this.$api.post('/v1.1.0/businessOrder', {
        client: 'miniProgram',
        businessPackageId: this.checkedPack.id,
        paymentChannelId: 13,
      }).then(res => {
        pay(res).then(res => {
          this.$router.replace('/')
        }).catch(err => {
          console.log(err)
        })
      })
    },
    hideLoading() {
      this.$toast.clear();
    }
  }
}
;
</script>

<style lang="less" scoped>
.dredge-contain {
  .dredge-header {
    height: 2.08rem;
    width: 100%;
  }

  .price-select {
    padding: 0 0.3rem;
    height: 1.5rem;
    margin-top: 0.3rem;

    .item-price-select {
      height: 1.5rem;
      background: #fff;
      border: 0.02rem solid #cad3df;
      text-align: center;
      flex: 1;
      color: #4a4a4a;
      position: relative;

      .price {
        margin-top: 0.5rem;
        font-size: 0.28rem;

        span {
          font-size: 0.48rem;
        }
      }

      .original-price {
        margin-top: 0.1rem;
        color: #4a4a4a;
        font-size: 0.2rem;

        .preferential {
          text-decoration: line-through;
        }
      }

      .select-icon {
        position: absolute;
        bottom: 0.1rem;
        right: 0.1rem;
      }

      .recommended {
        width: 0.81rem;
        height: 0.3rem;
        position: absolute;
        left: 0;
        top: 0;
        z-index: 1;
      }
    }

    .item-price-select.active-price-select {
      border: 0.02rem solid #ff5500;
      color: #ff5500;

      .price {
        color: #ff5500;
      }
    }
  }

  .introduction {
    display: block;
    width: 6.9rem;
    margin: 0.3rem auto 2rem auto;
  }

  .bottom-pay {
    position: fixed;
    bottom: 0;
    width: 100vw;
    height: 1.2rem;
    text-align: center;
    box-shadow: 0 0 20px 0 rgba(161, 174, 191, 0.5);

    .pay-price {
      width: 3rem;
      background: #fff;
      height: 100%;

      .pay-unit {
        color: #a1aebf;
        font-size: 0.24rem;
      }

      .pay-price-num {
        margin-top: 0.1rem;
        color: #ff5500;
        font-size: 0.36rem;
      }
    }

    .pay-button {
      flex: 1;
      line-height: 1.2rem;
      background: #ff9900;
      color: #fff;
      font-size: 0.36rem;
    }
  }
}
</style>
